var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-form-item__description is-bottom"},[_vm._v("\n    商品名称中请勿填写营销词，例如【火锅季】\n")])}
var staticRenderFns = []

export { render, staticRenderFns }